const Domains = {
  // Page
  Domains: "النطاقات",
  "Manage your store's domains and DNS settings": "إدارة نطاقات متجرك وإعدادات DNS",
  "Manage your store domains and DNS records": "إدارة نطاقات متجرك وسجلات DNS",
  "Active Domains": "النطاقات النشطة",
  "Your Domain Library": "مكتبة النطاقات",
  "Domains you own that are not currently assigned to a slot.":
    "النطاقات التي تمتلكها وغير مخصصة حالياً لأي موقع.",
  "Back": "رجوع",

  // Domain card labels
  "Primary Domain": "النطاق الرئيسي",
  "Alternative Domain": "النطاق البديل",
  "Not configured": "غير مُعدَّ",
  Platform: "المنصة",
  Cloudflare: "كلاودفلير",
  "External DNS": "DNS خارجي",
  "Make Primary": "جعله رئيسياً",
  Unlink: "إلغاء الربط",
  "Are you sure you want to unlink this domain?":
    "هل أنت متأكد من إلغاء ربط هذا النطاق؟",
  "The alternative domain will become your new primary domain. Continue?":
    "سيصبح النطاق البديل نطاقك الرئيسي الجديد. هل تريد المتابعة؟",
  "You can't unlink the domain you're currently using to access the dashboard":
    "لا يمكنك إلغاء ربط النطاق الذي تستخدمه حالياً للوصول إلى لوحة التحكم",

  // Header buttons
  "Get a Free Domain": "احصل على نطاق مجاني",
  "Buy a Domain": "شراء نطاق",
  "Link Domain": "ربط نطاق",

  // Pending verification banner
  "Verification pending for": "التحقق قيد الانتظار لـ",
  "complete the setup to activate this domain.": "أكمل الإعداد لتفعيل هذا النطاق.",
  "Continue Setup": "متابعة الإعداد",

  // Domain library
  Assign: "تعيين",
  "Set as Primary": "تعيين كرئيسي",
  "Set as Alternative": "تعيين كبديل",
  Purchased: "تم الشراء",
  "Awaiting Payment": "بانتظار الدفع",
  "Pending Payment": "بانتظار الدفع",
  "Re-activate": "إعادة تفعيل",

  // ordable subdomain
  "Get ordable subdomain": "نطاق فرعي من ordable",
  "Get an ordable subdomain": "احصل على نطاق فرعي من ordable",
  "Choose a subdomain for your store. It will be available at":
    "اختر نطاقاً فرعياً لمتجرك. سيكون متاحاً على",
  "Check Availability": "التحقق من التوفر",
  "Set as Alternative Domain": "تعيين كنطاق بديل",
  "Subdomain Created!": "تم إنشاء النطاق الفرعي!",
  "has been set as your alternative domain.": "تم تعيينه كنطاق بديل لمتجرك.",
  "This subdomain is not available. Try a different one.":
    "هذا النطاق الفرعي غير متاح. جرب اسماً مختلفاً.",
  "is available!": "متاح!",
  "is not available.": "غير متاح.",
  "e.g. mystore": "مثال: mystore",

  // Domain search modal
  "Search for a domain name to claim with your free credit.":
    "ابحث عن اسم نطاق للحصول عليه برصيدك المجاني.",
  "Search for a domain name to purchase. The price will be shown in your store's currency.":
    "ابحث عن اسم نطاق للشراء. سيظهر السعر بعملة متجرك.",
  "You can enter a full domain (mystore.com), www.mystore.com, or a subdomain like shop.mystore.com":
    "يمكنك إدخال نطاق كامل مثل mystore.com أو www.mystore.com أو shop.mystore.com",
  "e.g. mystore.com, www.mystore.com, shop.mystore.com":
    "مثال: mystore.com أو www.mystore.com أو shop.mystore.com",
  Search: "بحث",
  "Free with your domain credit": "مجاني برصيد النطاق الخاص بك",
  "Your store will be accessible at": "سيكون متجرك متاحاً على",
  "This domain exceeds the free credit limit. Please try a different domain to use your free credit, or purchase this one.":
    "يتجاوز هذا النطاق حد الرصيد المجاني. جرب نطاقاً آخر لاستخدام رصيدك، أو اشترِ هذا النطاق.",
  "is not available. Try a different name.": "غير متاح. جرب اسماً مختلفاً.",
  Claim: "احصل على",
  "Purchase for": "شراء بـ",
  "Redirecting to payment...": "جاري التحويل إلى الدفع...",
  "Domain Purchased!": "تم شراء النطاق!",
  "Domain purchased successfully!": "تم شراء النطاق بنجاح!",
  "Your new domain has been purchased and configured. You can now assign it to your store from the Domains page.":
    "تم شراء نطاقك الجديد وإعداده. يمكنك الآن تعيينه لمتجرك من صفحة النطاقات.",
  year: "سنة",

  // Domain link modal
  "Link Your Domain": "ربط نطاقك",
  "Enter Domain": "أدخل النطاق",
  "Verify Ownership": "التحقق من الملكية",
  "Update Nameservers": "تحديث خوادم الأسماء",
  "Enter the full domain with a subdomain that you want to link to your store.":
    "أدخل النطاق الكامل مع النطاق الفرعي الذي تريد ربطه بمتجرك.",
  "e.g. www.myshop.com or order.myshop.com":
    "مثال: www.myshop.com أو order.myshop.com",
  Next: "التالي",
  Linking: "جاري الربط",
  "Add the following TXT record to your domain's DNS settings at your current registrar/DNS provider:":
    "أضف سجل TXT التالي إلى إعدادات DNS لنطاقك لدى مزود الخدمة أو المسجِّل الحالي:",
  "Record Type": "نوع السجل",
  "Name/Host": "الاسم/المضيف",
  Value: "القيمة",
  Copy: "نسخ",
  "Copied!": "تم النسخ!",
  "After adding the TXT record, wait a few minutes for DNS propagation, then click Verify.":
    "بعد إضافة سجل TXT، انتظر بضع دقائق حتى ينتشر، ثم انقر على التحقق.",
  "This will cancel the current verification. Are you sure?":
    "سيؤدي هذا إلى إلغاء التحقق الحالي. هل أنت متأكد؟",
  "Cancel & link a different domain": "إلغاء وربط نطاق مختلف",
  "Ownership verified!": "تم التحقق من الملكية!",
  "Your domain has been added to Cloudflare. Now update your domain's nameservers at your registrar to:":
    "تمت إضافة نطاقك إلى Cloudflare. الآن حدِّث خوادم أسماء نطاقك لدى المسجِّل إلى:",
  "Nameserver changes can take up to 24 hours to propagate. Click the button below to check if they have been updated.":
    "قد تستغرق تغييرات خوادم الأسماء ما يصل إلى 24 ساعة للانتشار. انقر على الزر أدناه للتحقق.",
  "Check Nameservers": "التحقق من خوادم الأسماء",
  "Domain Linked!": "تم ربط النطاق!",
  "Domain linked successfully!": "تم ربط النطاق بنجاح!",
  "Your domain has been verified and is now active. You can assign it to your store from the Domains page.":
    "تم التحقق من نطاقك وهو الآن نشط. يمكنك تعيينه لمتجرك من صفحة النطاقات.",

  // DNS drawer
  "DNS Records": "سجلات DNS",
  DNS: "DNS",
  "Search records…": "البحث في السجلات...",
  "New Record": "سجل جديد",
  "No DNS records": "لا توجد سجلات DNS",
  Name: "الاسم",
  Content: "المحتوى",
  Edit: "تعديل",
  "Are you sure you want to delete this record?": "هل أنت متأكد من حذف هذا السجل؟",
  "Deleted successfully": "تم الحذف بنجاح",

  // Shared
  Buy: "شراء",
  Link: "ربط",
  Done: "تم",
  Cancel: "إلغاء",
  Yes: "نعم",
  No: "لا",
};

export default Domains;
